import { styled } from 'styled-components';
import { Table } from 'components/Base/Table';
import { TTask } from 'data/types/pillarsActionPlan.types';

export const StyledTaskTable = styled(Table)<{ dataSource?: TTask[] }>`
  && {
    .ant-table-thead {
      .ant-table-cell:first-child {
        pointer-events: none;
        background: ${({ theme }) => theme.colorWhitePrimary} !important;
        border: 0;
        border-top: 1px solid #dedede;
        border-bottom: 1px solid #dedede;
        border-start-start-radius: 0 !important;
      }
    }
    .ant-table-cell {
      padding: 16px !important;
    }

    .ant-picker {
      border: none !important;

      .ant-picker-input input {
        font-weight: 400 !important;
      }
    }
  }
`;
